// audioService.js
class AudioService {
    constructor() {
        this.audioContext = new (window.AudioContext ||
            window.webkitAudioContext)();
        this.leftOscillator = null;
        this.rightOscillator = null;
        this.gainNodeLeft = this.audioContext.createGain();
        this.gainNodeRight = this.audioContext.createGain();

        this.pannerLeft = this.audioContext.createStereoPanner();
        this.pannerRight = this.audioContext.createStereoPanner();
        this.pannerLeft.pan.value = -1;
        this.pannerRight.pan.value = 1;

        this.gainNodeLeft
            .connect(this.pannerLeft)
            .connect(this.audioContext.destination);
        this.gainNodeRight
            .connect(this.pannerRight)
            .connect(this.audioContext.destination);
    }

    startTone(channel, frequency, volume) {
        this.stopTone();

        if (channel === "L" || channel === "B") {
            this.leftOscillator = this.audioContext.createOscillator();
            this.leftOscillator.frequency.value = frequency;
            this.gainNodeLeft.gain.value = volume;
            this.leftOscillator.connect(this.gainNodeLeft);
            this.leftOscillator.start();
        }

        if (channel === "R" || channel === "B") {
            this.rightOscillator = this.audioContext.createOscillator();
            this.rightOscillator.frequency.value = frequency;
            this.gainNodeRight.gain.value = volume;
            this.rightOscillator.connect(this.gainNodeRight);
            this.rightOscillator.start();
        }
    }

    startToneForDuration(channel, frequency, duration, volume) {
        this.startTone(channel, frequency, volume);
        setTimeout(() => {
            this.stopTone();
        }, duration);
    }

    muteTone(channel) {
        if ((channel === "L" || channel === "B") && this.leftOscillator) {
            this.leftOscillator.stop();
            this.leftOscillator.disconnect();
            this.leftOscillator = null;
        }

        if ((channel === "R" || channel === "B") && this.rightOscillator) {
            this.rightOscillator.stop();
            this.rightOscillator.disconnect();
            this.rightOscillator = null;
        }
    }

    stopTone() {
        this.muteTone("B");
    }
}

const audioService = new AudioService();
export default audioService;
